import styled, { css } from "styled-components";

const lineBaseStyles = css`
  display: block;
  position: absolute;
  height: 2px; 
  width: 100%;
  background: #1D1D1DD9;
  border-radius: 3px;
  opacity: 1;
  left: 0;
  transition: 0.25s ease-in-out;
  transform-origin: left center;
`;

export const StyledButton = styled.button`
  width: 40px;
  height: 40px;
  cursor: pointer;
  outline: none;
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  @media ${({ theme }) => theme.media.nonMobileForHeader} {
    display: none;
  }
`;

export const Wrapper = styled.div`
  width: 18px;
  height: 14px;
  position: relative;
  transform: rotate(0deg);
  transition: 0.5s ease-in-out;
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
  margin: 0;
`;

export const Line = styled.span`
  ${lineBaseStyles}

  ${({ $position }) => {
    switch ($position) {
      case "top":
        return `top: 0px;`;
      case "middle":
        return `top: 6px;`;
      case "bottom":
        return `top: 12px;`;
      default:
        return "";
    }
  }}

  ${({ $isOpen, $position }) =>
    $isOpen &&
    `
    ${
      $position === "top"
        ? `transform: rotate(45deg); top: -1px; left: 1px;`
        : ""
    }
    ${$position === "middle" ? `width: 0%; opacity: 0;` : ""}
    ${
      $position === "bottom"
        ? `transform: rotate(-45deg); top: 12px; left: 1px;`
        : ""
    }
  `}
`;
